import { render, staticRenderFns } from "./SwitchModal.vue?vue&type=template&id=98e40288&scoped=true"
import script from "./SwitchModal.vue?vue&type=script&lang=js"
export * from "./SwitchModal.vue?vue&type=script&lang=js"
import style0 from "./SwitchModal.vue?vue&type=style&index=0&id=98e40288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e40288",
  null
  
)

export default component.exports